export type FormateurTarifsDraft = {
  enabled: boolean;
  montantHoraireCdf: string;
  primeTransportJourCdf: string;
  referenceUsdHoraire: string;
  referenceUsdTransport: string;
};

export function emptyFormateurTarifsDraft(): FormateurTarifsDraft {
  return {
    enabled: false,
    montantHoraireCdf: '',
    primeTransportJourCdf: '',
    referenceUsdHoraire: '',
    referenceUsdTransport: '',
  };
}

export function buildFormateurTarifsDraftFromApi(payload: {
  utilisePersonnalise?: boolean;
  global?: {
    montantHoraireCdf?: number | string;
    primeTransportJourCdf?: number | string;
    referenceUsdHoraire?: number | string | null;
    referenceUsdTransport?: number | string | null;
  } | null;
  personnalise?: {
    montantHoraireCdf?: number | string;
    primeTransportJourCdf?: number | string;
    referenceUsdHoraire?: number | string | null;
    referenceUsdTransport?: number | string | null;
  } | null;
  effectif?: {
    montantHoraireCdf?: number | string;
    primeTransportJourCdf?: number | string;
    referenceUsdHoraire?: number | string | null;
    referenceUsdTransport?: number | string | null;
  } | null;
}): FormateurTarifsDraft {
  const enabled = Boolean(payload.utilisePersonnalise);
  const source =
    enabled && payload.personnalise
      ? payload.personnalise
      : payload.effectif ?? payload.global ?? payload.personnalise ?? {};

  return {
    enabled,
    montantHoraireCdf: source.montantHoraireCdf != null ? String(source.montantHoraireCdf) : '',
    primeTransportJourCdf:
      source.primeTransportJourCdf != null ? String(source.primeTransportJourCdf) : '',
    referenceUsdHoraire:
      source.referenceUsdHoraire != null && source.referenceUsdHoraire !== ''
        ? String(source.referenceUsdHoraire)
        : '',
    referenceUsdTransport:
      source.referenceUsdTransport != null && source.referenceUsdTransport !== ''
        ? String(source.referenceUsdTransport)
        : '',
  };
}

export function formateurTarifsDraftToPayload(draft: FormateurTarifsDraft) {
  if (!draft.enabled) {
    return { enabled: false };
  }
  return {
    enabled: true,
    tarif: {
      montantHoraireCdf: Number(draft.montantHoraireCdf),
      primeTransportJourCdf: Number(draft.primeTransportJourCdf),
      referenceUsdHoraire:
        draft.referenceUsdHoraire.trim() === '' ? null : Number(draft.referenceUsdHoraire),
      referenceUsdTransport:
        draft.referenceUsdTransport.trim() === '' ? null : Number(draft.referenceUsdTransport),
    },
  };
}
